/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Report } from '../models/Report';
import type { ReportRequest } from '../models/ReportRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminReportService {

    /**
     * get list of reports
     * @returns any Success
     * @throws ApiError
     */
    public static listAdminReports({
        limit,
        offset,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<{
        rows?: Array<Report>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/report',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create report
     * @returns Report Success
     * @throws ApiError
     */
    public static createAdminReport({
        requestBody,
    }: {
        requestBody: ReportRequest,
    }): CancelablePromise<Report> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/report',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * upload image report
     * @returns any Success
     * @throws ApiError
     */
    public static uploadReportImage({
        formData,
    }: {
        formData: {
            file?: Blob;
        },
    }): CancelablePromise<{
        bucket?: string | null;
        key?: string | null;
        name?: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/report/image',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get Report Information
     * @returns Report Success
     * @throws ApiError
     */
    public static getAdminReport({
        id,
    }: {
        /**
         * Report ID
         */
        id: number,
    }): CancelablePromise<Report> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/report/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update Report Information
     * @returns ReportRequest Success
     * @throws ApiError
     */
    public static updateAdminReport({
        id,
        requestBody,
    }: {
        /**
         * Report ID
         */
        id: number,
        requestBody: ReportRequest,
    }): CancelablePromise<ReportRequest> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/report/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Report
     * @returns any Success
     * @throws ApiError
     */
    public static deleteReportAdmin({
        id,
    }: {
        /**
         * Report ID
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/report/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get Report Information
     * @returns any Success
     * @throws ApiError
     */
    public static getAdminReportData({
        id,
        limit,
        offset,
    }: {
        /**
         * Report ID
         */
        id: number,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<{
        rows?: Array<Record<string, any>>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/report/{id}/data',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update Report Information
     * @returns ReportRequest Success
     * @throws ApiError
     */
    public static updateReportData({
        id,
        requestBody,
    }: {
        /**
         * Report ID
         */
        id: number,
        requestBody: ReportRequest,
    }): CancelablePromise<ReportRequest> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/report/{id}/data',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Report
     * @returns any Success
     * @throws ApiError
     */
    public static deleteReportData({
        id,
    }: {
        /**
         * Report ID
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/report/{id}/data',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
